import React from "react";
import {
  WidgetDetails,
  Title,
} from "../../assets/styled/RakthermWorldwide";

const MegaProjects = () => {
  return (
    <>
      <Title>MEGA PROJECTS REFERENCES</Title>

      <WidgetDetails>
        Engineered piping systems to build the most iconic projects in the
        world!
      </WidgetDetails>

      <WidgetDetails>
        It’s an accomplishment to be a part of these major construction
        projects, to see how RAKtherm pushes the technical boundaries in piping
        technology to meet the rising global demand.
      </WidgetDetails>

      <WidgetDetails>
        Our in-house engineering team’s expertise have mastered the technical
        requirements and specifications based upon the functional requirements.
        These detailed specifications are used to define specific technical
        approach and implementation that will be used to fulfill MEP system
        requirements. Choosing RAKtherm guarantees excellence across every
        aspect of MEP components needed for new development.
      </WidgetDetails>
    </>
  );
};

export default MegaProjects;
